/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable react/jsx-no-bind */
import { Dialog, Transition } from '@headlessui/react';
import { UilMultiply } from '@iconscout/react-unicons';
import { Fragment } from 'react';
import { CheckIcon } from '@heroicons/react/24/solid';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function Modal({
  setIsOpen,
  isOpen,
  children,
  setStep,
  steps,
  setSteps,
  title,
}) {
  function closeModal() {
    setIsOpen(false);
    setTimeout(() => {
      setStep(0);
      setSteps([
        { id: 1, name: 'Step 1', href: '#', status: 'current' },
        { id: 2, name: 'Step 2', href: '#', status: 'upcoming' },
        { id: 3, name: 'Step 3', href: '#', status: 'upcoming' },
      ]);
    }, 500);
  }

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as='div' className='relative z-10' onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'
        >
          <div className='fixed inset-0 bg-black bg-opacity-25' />
        </Transition.Child>

        <div className='fixed inset-0 overflow-y-auto'>
          <div className='flex min-h-full items-center justify-center p-4 text-center'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 scale-95'
              enterTo='opacity-100 scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 scale-100'
              leaveTo='opacity-0 scale-95'
            >
              <Dialog.Panel className='w-full max-w-md transform overflow-hidden rounded-2xl bg-[#0d111c] p-6 text-left align-middle shadow-xl transition-all'>
                <div className='flex justify-between'>
                  <div>
                    <Dialog.Title
                      as='h3'
                      className='text-xl font-semibold leading-6 text-white'
                    >
                      {title}
                    </Dialog.Title>
                  </div>
                  <div>
                    <button
                      type='button'
                      className='text-[#0d111c] font-semibold'
                      onClick={closeModal}
                    >
                      <UilMultiply />
                    </button>
                  </div>
                </div>

                {children}
                {steps !== null && (
                  <div className='flex justify-center mt-4'>
                    <nav aria-label='Progress'>
                      <ol role='list' className='flex items-center'>
                        {steps.map((step, stepIdx) => (
                          <li
                            key={step.name}
                            className={classNames(
                              stepIdx !== steps.length - 1
                                ? 'pr-8 sm:pr-20'
                                : '',
                              'relative'
                            )}
                          >
                            {step.status === 'complete' ? (
                              <>
                                <div
                                  className='absolute inset-0 flex items-center'
                                  aria-hidden='true'
                                >
                                  <div className='h-0.5 w-full bg-[#40A838]' />
                                </div>
                                <a
                                  href='#'
                                  className='relative w-8 h-8 flex items-center justify-center bg-[#40A838] rounded-full'
                                >
                                  <CheckIcon
                                    className='w-5 h-5 text-white'
                                    aria-hidden='true'
                                  />
                                  <span className='sr-only'>{step.name}</span>
                                </a>
                              </>
                            ) : step.status === 'current' ? (
                              <>
                                <div
                                  className='absolute inset-0 flex items-center'
                                  aria-hidden='true'
                                >
                                  <div className='h-0.5 w-full bg-gray-200' />
                                </div>
                                <a
                                  href='#'
                                  className='relative w-8 h-8 flex items-center justify-center bg-[#0d111c] border-2 border-[#40A838] rounded-full'
                                  aria-current='step'
                                >
                                  <span
                                    className='h-2.5 w-2.5 bg-[#40A838] rounded-full'
                                    aria-hidden='true'
                                  />
                                  <span className='sr-only'>{step.name}</span>
                                </a>
                              </>
                            ) : (
                              <>
                                <div
                                  className='absolute inset-0 flex items-center'
                                  aria-hidden='true'
                                >
                                  <div className='h-0.5 w-full bg-gray-200' />
                                </div>
                                <a
                                  href='#'
                                  className='group relative w-8 h-8 flex items-center justify-center bg-[#0d111c] border-2 border-gray-300 rounded-full hover:border-gray-400'
                                >
                                  <span
                                    className='h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300'
                                    aria-hidden='true'
                                  />
                                  <span className='sr-only'>{step.name}</span>
                                </a>
                              </>
                            )}
                          </li>
                        ))}
                      </ol>
                    </nav>
                  </div>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
